// extracted by mini-css-extract-plugin
export default {"btn":"BlueButton_btn__ZlgJF"};